// extracted by mini-css-extract-plugin
module.exports = {"hero":"hero_hero__sdvLc","text-small":"hero_text-small__tC54s","hero-text":"hero_hero-text__4DhTR"};